import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase'
import { UsersRepository } from '@/core/infrastructure/repositories/users/core/UsersRepository'
import FetchAllUserUseCase from '@/core/useCases/users/FetchAllUserUseCase.ts'
import CreateUserUseCase from '@/core/useCases/users/CreateUserUseCase.ts'
import UpdateUserUseCase from '@/core/useCases/users/UpdateUserUseCase.ts'
import BlockUserUseCase from '@/core/useCases/users/BlockUserUseCase.ts'
import UnblockUserUseCase from '@/core/useCases/users/UnblockUserUseCase.ts'
import ResetPasswordUserUseCase from '@/core/useCases/users/ResetPasswordUserUseCase.ts'
import FetchUserByIdentifierUseCase from '@/core/useCases/users/FetchUserByidentifierUseCase.ts'
import VerifyEmailUserUseCase from '@/core/useCases/users/VerifyEmailUserUseCase.ts'
import SendEmailResetPasswordUseCase from '@/core/useCases/users/SendEmailResetPasswordUseCase.ts'

export class UsersModule extends ModuleBase {
  initialize(): void {
    this.initializeCore()
  }

  private initializeCore(): void {
    const usersRepository = new UsersRepository()
    this.registerRepository(UsersRepository, usersRepository)

    const fetchUserByIdentifierUseCase = new FetchUserByIdentifierUseCase(usersRepository)
    this.registerUseCase(FetchUserByIdentifierUseCase, fetchUserByIdentifierUseCase)

    const fetchAllUsersUseCase = new FetchAllUserUseCase(usersRepository)
    this.registerUseCase(FetchAllUserUseCase, fetchAllUsersUseCase)

    const createUserUseCase = new CreateUserUseCase(usersRepository)
    this.registerUseCase(CreateUserUseCase, createUserUseCase)

    const updateUserUseCase = new UpdateUserUseCase(usersRepository)
    this.registerUseCase(UpdateUserUseCase, updateUserUseCase)

    const blockUserUseCase = new BlockUserUseCase(usersRepository)
    this.registerUseCase(BlockUserUseCase, blockUserUseCase)

    const unblockUserUseCase = new UnblockUserUseCase(usersRepository)
    this.registerUseCase(UnblockUserUseCase, unblockUserUseCase)

    const resetPasswordUserUseCase = new ResetPasswordUserUseCase(usersRepository)
    this.registerUseCase(ResetPasswordUserUseCase, resetPasswordUserUseCase)

    const verifyUserEmailUseCase = new VerifyEmailUserUseCase(usersRepository)
    this.registerUseCase(VerifyEmailUserUseCase, verifyUserEmailUseCase)

    const sendEmailResetPasswordUseCase = new SendEmailResetPasswordUseCase(usersRepository)
    this.registerUseCase(SendEmailResetPasswordUseCase, sendEmailResetPasswordUseCase)
  }
}
